export { default } from './GridKioskDevices.vue'
